import { render, staticRenderFns } from "./MainBranchEdit.vue?vue&type=template&id=0e16a198&scoped=true"
import script from "./MainBranchEdit.vue?vue&type=script&lang=js"
export * from "./MainBranchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16a198",
  null
  
)

export default component.exports